/**
 * SOLUTE / BILLIGER.DE ATTRIBUTION -- issue #860.
 *
 * billiger.de's landing code ("code 1", installed outside this repo) stores the visitor's click as
 * localStorage['soluteclid'] = "<ms timestamp> <landing URL>". Their conversion code ("code 2") reads that
 * key back on the order confirmation page. On Shopify that read can never succeed: the confirmation code
 * runs as a Custom Pixel, and Custom Pixels live in a sandboxed iframe that cannot reach the storefront's
 * localStorage. So solute received no conversions at all.
 *
 * This file carries the click across that wall on the CART: it copies the stored value into the cart
 * attribute `_soluteclid`, which travels into checkout and onto the order. The conversion is then sent from
 * the pixel's checkout_completed event (checkout.attributes) or server-side from the order -- see #860.
 *
 * It writes the attribute only when there is a click within solute's own 30-day window and the cart does
 * not already carry it, so an ordinary visitor costs nothing and a solute visitor costs one request per cart.
 * The landing URL is read here as well, so the capture does not depend on code 1 having run first.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'soluteclid';
  var ATTRIBUTE = '_soluteclid';
  var TTL = 1000 * 60 * 60 * 24 * 30;

  function read() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function currentClick() {
    if (new URLSearchParams(location.search).has('soluteclid')) {
      var fresh = new Date().getTime() + ' ' + location.href;

      try {
        localStorage.setItem(STORAGE_KEY, fresh);
      } catch (e) {}

      return fresh;
    }

    var stored = read();

    if (!stored) {
      return null;
    }

    var parts = stored.split(' ', 2);

    if (!parts[1] || !(parseInt(parts[0], 10) + TTL > new Date().getTime())) {
      return null;
    }

    return stored;
  }

  var script = document.currentScript;
  var onCart = script ? script.getAttribute('data-cart-soluteclid') : '';
  var click = currentClick();

  if (!click || click === onCart) {
    return;
  }

  var attributes = {};
  attributes[ATTRIBUTE] = click;

  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  }).catch(function () {});
})();
